<template>
  <div>
    <ts-page-title
      :title="$t('employeeStatusReason.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('employeeStatusReason.pageTitle'),
          active: true,
        },
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper class="tw-flex tw-items-center tw-justify-between">
        <a-button type="primary" @click="addNew">
          {{ $t("addNew") }}
        </a-button>
        <div class="tw-justify-end">
          <a-input
            v-model="search"
            v-tooltip="$t('employeeStatusReason.search')"
            :placeholder="$t('search')"
            style="width: 250px"
            class="inline-block"
          />
        </div>
      </ts-panel-wrapper>
      <div class="tw-overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.reason }}</td>
            <td>{{ record.employee_status.status }}</td>
            <td class="text-center tw-space-x-3">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end tw-p-4">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-panel>

    <!-- form-action -->
    <a-modal
      v-if="showForm"
      v-model="showForm"
      :title="$t('employeeStatusReason.pageTitle')"
      centered
      :maskClosable="false"
      @cancel="clearEdit"
      :zIndex="1020"
      :footer="null"
    >
      <from-action @cancel="clearEdit" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapState } from "vuex";
import FromAction from "./form";

export default {
  name: "employeeStatusReasonIndex",
  components: {
    FromAction,
  },
  data() {
    return {
      loading: false,
      showForm: false,
    };
  },
  computed: {
    ...mapState("humanResource/employeeStatusReason", [
      "resources",
      "pagination",
    ]),
    search: {
      get() {
        return this.$store.state.humanResource.employeeStatusReason.search;
      },
      set(newValue) {
        this.$store.commit(
          "humanResource/employeeStatusReason/SET_SEARCH",
          newValue
        );
        this.$store.commit(
          "humanResource/employeeStatusReason/RESET_CURRENT_PAGE"
        );
      },
    },
    columns() {
      return [
        { name: this.$t("employeeStatusReason.reason") },
        { name: this.$t("employeeStatusReason.status") },
        {
          name: this.$t("actions"),
          style: "text-align:center; width: 1px;",
        },
      ];
    },
  },
  methods: {
    fetchData(attributes) {
      this.loading = true;
      this.$store
        .dispatch("humanResource/employeeStatusReason/fetch", { ...attributes })
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({ type: "error", text: error.message });
        });
    },
    addNew() {
      this.showForm = true;
    },
    edit(record) {
      this.$store.commit(
        "humanResource/employeeStatusReason/SET_EDIT_DATA",
        record
      );
      this.showForm = true;
    },
    clearEdit() {
      this.$store.commit(
        "humanResource/employeeStatusReason/SET_EDIT_DATA",
        {}
      );
      this.showForm = false;
      this.fetchData();
    },
    deleteRecord(record) {
      record._deleting = true;
      this.$store
        .dispatch(
          "humanResource/employeeStatusReason/destroy",
          record.status_reason_id
        )
        .then((response) => {
          this.$notify({ type: "success", text: response.message });
          this.fetchData();
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          record._deleting = false;
        });
    },
  },
  watch: {
    search: debounce(function () {
      this.fetchData();
    }, 500),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("humanResource/shift/RESET_STATE");
    next();
  },
};
</script>
